import { useQuery } from '@tanstack/react-query';
import storeService, { PosCredentialsSummary } from '../../../../services/storeService';
import { Store } from '../../types';

export const useAllStores = (getAll: boolean = false) => {
  return useQuery<Store[]>({
    queryKey: ['allStores', getAll],
    queryFn: () => storeService.getAllStores(getAll),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};

export const useStoreDetails = (storeId: string) => {
  return useQuery<Store>({
    queryKey: ['storeDetails', storeId],
    queryFn: () => storeService.getStoreById(storeId),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    enabled: !!storeId,
  });
};

export const usePosCredentialsSummary = (storeId: string) => {
  return useQuery<PosCredentialsSummary>({
    queryKey: ['posCredentialsSummary', storeId],
    queryFn: () => storeService.getPosCredentialsSummary(storeId),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled: !!storeId,
    retry: false,
  });
};
